import React from "react";
import {
  ArrowRightIcon,
  CalendarIcon,
  ChartIcon,
  GraduationIcon,
  NetworkIcon,
  SettingsIcon,
  SparklesIcon,
  UsersIcon,
} from "../Icons";
import { jumpTo } from "../ui";
import { PlatformSection, ShowcaseHeader } from "./PlatformShowcase";
import { CAPABILITIES } from "./content";

const CAPABILITY_ICONS: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  "programme-setup": SettingsIcon,
  "learning-journeys": GraduationIcon,
  "mentor-matching": NetworkIcon,
  "session-management": CalendarIcon,
  "engagement-tracking": UsersIcon,
  "ai-summaries": SparklesIcon,
  reports: ChartIcon,
};

export default function CapabilityGrid() {
  return (
    <PlatformSection id="capabilities">
      <ShowcaseHeader
        id="capabilities"
        label="Platform capabilities"
        heading="The operating layer behind a structured programme."
        body="You get one connected workflow, from the first participant invitation to the final outcome report."
      />

      <ul className="tw-mt-12 tw-mb-0 tw-grid tw-list-none tw-grid-cols-4 tw-gap-5 tw-p-0 sm:tw-grid-cols-2 xs:tw-grid-cols-1">
        {CAPABILITIES.map((capability) => {
          const Icon = CAPABILITY_ICONS[capability.id];

          return (
            <li key={capability.id} className="tw-min-w-0">
              <article className="tw-flex tw-h-full tw-flex-col tw-rounded-2xl tw-border tw-border-[#d5e4ef] tw-bg-white tw-p-6 tw-transition-shadow hover:tw-shadow-[0_18px_50px_rgba(27,93,139,.12)]">
                <Icon aria-hidden className="tw-h-5 tw-w-5 tw-shrink-0 tw-text-[#087bd3]" />

                <h3 className="tw-mt-4 tw-mb-0 tw-text-base tw-font-black tw-leading-6 tw-text-[#1c3854]">
                  {capability.title}
                </h3>
                <p className="tw-mt-2 tw-mb-0 tw-text-sm tw-leading-6 tw-text-[#60768c]">
                  {capability.body}
                </p>

                <a
                  href={`#${capability.section}`}
                  onClick={jumpTo(capability.section)}
                  className="tw-mt-auto tw-inline-flex tw-items-center tw-gap-1.5 tw-pt-5 tw-text-sm tw-font-black tw-text-[#0068b8] tw-no-underline hover:tw-text-[#005a9f] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#087bd3]"
                >
                  See capability
                  <ArrowRightIcon aria-hidden className="tw-h-3.5 tw-w-3.5 tw-shrink-0" />
                  <span className="tw-sr-only">: {capability.title}</span>
                </a>
              </article>
            </li>
          );
        })}
      </ul>
    </PlatformSection>
  );
}
